module.exports = __webpack_public_path__ + "static/media/img-109.d0ffcb09.jpg";